export const headerPurple = "#a207fcff";
export const primaryDark = "#8300E9";
export const secondaryDark = "#C180F4";

export const backgroundLight = "#fafdffff";
